import Button from "domains/ui/components/Button";
import Icon from "domains/ui/components/Icon";
import WithGradientEffect from "domains/ui/components/WithGradientEffect";

import { Center, Skeleton, Text, VStack } from "@chakra-ui/react";

export default function ModelShowDetailsImageFallback({
  isModelOwned,
  isModelTraining,
  onClickUploadImage,
}: {
  onClickUploadImage?: () => void;
  isModelOwned: boolean;
  isModelTraining: boolean;
}) {
  const handleFallbackOnClick = () => {
    if (onClickUploadImage && isModelOwned && !isModelTraining) {
      onClickUploadImage();
    }
  };

  const canAccessImageSelector = isModelOwned && !isModelTraining;
  return (
    <Center
      flex={1}
      borderWidth={1}
      _hover={
        canAccessImageSelector
          ? {
              bg: "whiteAlpha.100",
              transition: "background-color 0.2s",
            }
          : {}
      }
      cursor={canAccessImageSelector ? "pointer" : "default"}
      onClick={handleFallbackOnClick}
      rounded="lg"
    >
      {!onClickUploadImage ? (
        <Skeleton
          w="full"
          h="full"
          endColor="whiteAlpha.100"
          fadeDuration={2}
          rounded="lg"
          startColor="whiteAlpha.300"
        />
      ) : (
        <Center w={["90%", "90%", "100%"]}>
          {canAccessImageSelector ? (
            <VStack>
              <Button
                rounded="full"
                display={["none", "none", "flex"]}
                w={9}
                h={9}
              >
                <Icon id="Ui/Pin/Solid" w={4} h={4} />
              </Button>
              <Text
                sx={{
                  whiteSpace: "normal",
                  overflow: "hidden",
                }}
                textAlign="center"
                noOfLines={[2, 2, 1]}
                size={["body.xs", "body.sm", "body.md"]}
              >
                Pin Image
              </Text>
            </VStack>
          ) : (
            <WithGradientEffect>
              <Center h="full">
                <Icon color="whiteAlpha.100" id="Ui/Image" w="30%" h="30%" />
              </Center>
            </WithGradientEffect>
          )}
        </Center>
      )}
    </Center>
  );
}
